export { default as Cart } from '../../components/Cart.vue'
export { default as CartItem } from '../../components/CartItem.vue'
export { default as Footer } from '../../components/Footer.vue'
export { default as Header } from '../../components/Header.vue'
export { default as InputAddress } from '../../components/InputAddress.vue'
export { default as InputAddressMaster } from '../../components/InputAddressMaster.vue'
export { default as Loading } from '../../components/Loading.vue'
export { default as Payment } from '../../components/Payment.vue'
export { default as Product } from '../../components/Product.vue'
export { default as Template } from '../../components/Template.vue'
export { default as Zipfind } from '../../components/Zipfind.vue'

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
